import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  index = 'CheckAntispyAntiSpy',
  quiz = 'CheckAntispyAntiSpyQuiz',
  help = 'CheckAntispyAntiSpyHelp',
  security = 'CheckAntispyAntiSpySecurity',
  leaked = 'CheckAntispyAntiSpyLeaked',
  trusted = 'CheckAntispyAntiSpyTrusted',
  finish = 'CheckAntispyAntiSpyFinish',
  preparing = 'CheckAntispyAntiSpyPreparing',
  auth = 'CheckAntispyAntiSpyAuth',
  payment = 'CheckAntispyAntiSpyPayment',
}

function preloadModule(name: MODULE_ROUTE) {
  const parentRoute = routes.find((layoutRoute) =>
    layoutRoute.children?.find((route) => route.name === name),
  );

  const route = parentRoute?.children?.find((route) => route.name === name);

  if (route && 'component' in route && typeof route.component === 'function') {
    (route.component as unknown as () => void)();
  }
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/check-antispy/',
    component: () => import('@/modules/check-antispy/layout/LayoutPage.vue'),
    meta: {
      i18nAlias: 'pricing',
    },
    children: [
      {
        path: '',
        name: MODULE_ROUTE.index,
        component: () =>
          import('@/modules/check-antispy/pages/index/PageSafeOnline.vue'),
        meta: {
          abtestGroup: 1,
        },
        beforeEnter() {
          setTimeout(() => {
            Object.values(MODULE_ROUTE)
              .filter((moduleName) => moduleName !== MODULE_ROUTE.index)
              .forEach((moduleName) =>
                preloadModule(moduleName as MODULE_ROUTE),
              );
          }, 1000);
        },
      },
      {
        path: 'help/',
        name: MODULE_ROUTE.help,
        component: () =>
          import('@/modules/check-antispy/pages/help/PageSafeOnlineHelp.vue'),
      },
      {
        path: 'security/',
        name: MODULE_ROUTE.security,
        component: () =>
          import(
            '@/modules/check-antispy/pages/security/PageSafeOnlineSecurity.vue'
          ),
      },
      {
        path: 'leaked/',
        name: MODULE_ROUTE.leaked,
        component: () =>
          import(
            '@/modules/check-antispy/pages/leaked/PageSafeOnlineLeaked.vue'
          ),
      },
      {
        path: 'trusted/',
        name: MODULE_ROUTE.trusted,
        component: () =>
          import(
            '@/modules/check-antispy/pages/trusted/PageSafeOnlineTrusted.vue'
          ),
      },
      {
        path: 'finish/',
        name: MODULE_ROUTE.finish,
        component: () =>
          import(
            '@/modules/check-antispy/pages/finish/PageSafeOnlineFinish.vue'
          ),
      },
      {
        path: 'quiz/',
        name: MODULE_ROUTE.quiz,
        component: () =>
          import('@/modules/check-antispy/pages/quiz/PageQuiz.vue'),
      },
      {
        path: 'preparing/',
        name: MODULE_ROUTE.preparing,
        component: () =>
          import('@/modules/check-antispy/pages/preparing/PagePreparing.vue'),
      },
      {
        path: 'auth/',
        name: MODULE_ROUTE.auth,
        component: () =>
          import('@/modules/check-antispy/pages/auth/PageAuth.vue'),
      },
      {
        path: 'payment/',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/check-antispy/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
